import AccountForm from '@/components/shared/AccountForm'
import AdminLayout from '@/layouts/AdminLayout'

interface Props {
  user: { name: string | null; email_address: string }
}

export default function AdminAccountShow({ user }: Props) {
  return <AccountForm user={user} patchUrl="/admin/account" />
}

AdminAccountShow.layout = (page: React.ReactNode) => (
  <AdminLayout>{page}</AdminLayout>
)
